import { fetcher } from "helpers/fetcher";

import {
  TUpdateStaffMaternityChldrenLeaveReq,
  TUpdateStaffMaternityChldrenLeaveRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateStaffMaternityChldrenLeave = async (
  payload: TUpdateStaffMaternityChldrenLeaveReq
) => {
  return await fetcher<
    TUpdateStaffMaternityChldrenLeaveRes,
    TUpdateStaffMaternityChldrenLeaveReq["data"]
  >(ENDPOINT.USER.UPDATE_STAFF_MATERNITY_CHILDREN_LEAVE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]:
        ENDPOINT.USER.UPDATE_STAFF_MATERNITY_CHILDREN_LEAVE.version,
    },
  });
};

export const mutationUpdateStaffMaternityChldrenLeave = async (
  payload: TUpdateStaffMaternityChldrenLeaveReq
) => {
  return (await updateStaffMaternityChldrenLeave(payload)).data.message;
};

mutationUpdateStaffMaternityChldrenLeave._key = (
  payload: TUpdateStaffMaternityChldrenLeaveReq
) => [ENDPOINT.USER.UPDATE_STAFF_MATERNITY_CHILDREN_LEAVE.url, payload];
